import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import React, { useContext } from "react";
import { Image } from "../../../Styles/style";

import image from "../../../../assets/Images/dashboardImage.png";
import SectionsHeading from "../../MainComponent/SectionsHeading";
import Paragraph from "../../MainComponent/Paragraph";
import CustomButton from "../../MainComponent/CustomBtn";
import { WalletContext } from "../../../Pages/Dashborad";
const GridWrapper = styled(Grid)`
  display: grid;
  place-items: center;
  width: 100%;
  height: auto;
`;
const CardGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: linear-gradient(to top, #0d0d0d, #000000);
  height: auto;
  padding: 40px 0;
  border-radius: 20px;
  z-index: 1;
`;

const WalletConnectCard = () => {
    const {connectState, setConnectState} = useContext(WalletContext);
    console.log(connectState);
    return (
    
    <GridWrapper container>
      <CardGrid item xs={10}>
        <Image mw="100px" src={image} />
        <SectionsHeading fm="PoppinsSB" fs="22px" ta="center" color="#FC9D00">
          Please, Connect Your Wallet
        </SectionsHeading>
        <Paragraph fs="12px" ta="center">
          Please connect your wallet to see your supplies, borrowings, and open
          positions.
        </Paragraph>
        <CustomButton onClick={()=> {setConnectState(true)}} w="150px" c="#fff" bgc="#53616f8a" hbgc="#fff" hc="#000">
          Connect Wallet
        </CustomButton>
      </CardGrid>
    </GridWrapper>
  );
};

export default WalletConnectCard;
